import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_UMS_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Helper to get the token directly if needed for specialized calls,
 * though the interceptor below handles this automatically for 99% of cases.
 */
export async function getRawAuthToken() {
  const session = await fetchAuthSession({ forceRefresh: true });
  const token = session.tokens?.idToken?.toString();
  if (!token) throw new Error("No idToken available");
  return token;
}

// REQUEST INTERCEPTOR: Automatically injects the JWT before every call
apiClient.interceptors.request.use(async (config) => {
  try {
    // Attempt to get the token
    const token = await getRawAuthToken();

    if (token) {
      config.headers.Authorization = token;
    }
  } catch (error) {
    // DO NOT REJECT. Just log it and let the request proceed.
    // If the endpoint is public (Auth: NONE), it will succeed.
    // If the endpoint is private, the server will return a 401 anyway.
    console.warn("Guest session: Proceeding without Authorization header.");
  }

  return config; // Always return config to let the request happen
});


// RESPONSE INTERCEPTOR: Global error handling (e.g., redirect to login on 401)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Session expired or unauthorized. Redirecting...");
      // Optional: window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;